import React from 'react';
import { useRoutePlan } from '../apiHooks';
import Loader from '../../components/loader';
import RoutesMap from './routesMap';
import { useDeliveries, useRoutes } from './apiHooks';

const RoutePlanView = ({ match, setActiveDelivery, activeDelivery, activeRouteWithColor, setActiveRouteWithColor }) => {
  const { routePlan } = useRoutePlan({
    routePlanId: match.params.routePlanId,
  });

  const { deliveries } = useDeliveries({
    routePlanId: routePlan?.id,
  });

  const { routes } = useRoutes({
    routePlanId: routePlan?.id,
  });

  // needs to be here, otherwise map unmounts for some reason and map instance throws error
  if (!routePlan || !deliveries || !routes) {
    return <Loader show={true} />;
  }

  return (
    <>
      <div className="route-planner-view">
        <RoutesMap
          routes={routes}
          routePlan={routePlan}
          deliveries={deliveries}
          setActiveDelivery={setActiveDelivery}
          activeDelivery={activeDelivery}
          activeRouteWithColor={activeRouteWithColor}
          setActiveRouteWithColor={setActiveRouteWithColor}
        />
      </div>
    </>
  );
};

export default RoutePlanView;
